const handlers = {
    history: {
        balance: {
            set: 'history_balance_set'
        },
        date: {
            set: 'history_date_set'
        }
    }
};

const initVuexState = function(state) {
    state.history = {
        balance: null,
        date: new Date()
    };
};

const initGetters = function(getters) {
    getters.history = (state => state.history);
};

const initActions = function(actions) {
    actions[handlers.history.balance.set] = ({ commit }, balance) => { commit(handlers.history.balance.set, balance); };
    actions[handlers.history.date.set] = ({ commit }, date) => { commit(handlers.history.date.set, date); };
};

const initMutations = function(mutations) {
    mutations[handlers.history.balance.set] = (state, balance) => (state.history.balance = balance);
    mutations[handlers.history.date.set] = (state, date) => (state.history.date = date);
};

const initAppState = function(appState, store) {
    appState.history = {
        balance: {
            get: () => store.getters.history.balance,
            set: (balance) => store.dispatch(handlers.history.balance.set, balance)
        },
        date: {
            get: () => store.getters.history.date,
            set: (date) => store.dispatch(handlers.history.date.set, date)
        }
    };
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./skins/bulmasite/data/history.js